'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _HomeSearch = require('./HomeSearch.scss');

var _HomeSearch2 = _interopRequireDefault(_HomeSearch);

var _reactIntl = require('react-intl');

var _DestinationSelect = require('components/General/DestinationSelect');

var _DestinationSelect2 = _interopRequireDefault(_DestinationSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  THHomeSearch: {
    displayName: 'THHomeSearch'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Home/THHomeSearch.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import FontAwesome from 'react-fontawesome';


// import Calendar from 'containers/Calendar/Calendar';

// import _ from 'lodash';
// import Scroll from 'react-scroll';
// const ScrollLink = Scroll.Link;
var THHomeSearch = _wrapComponent('THHomeSearch')((_dec = (0, _reactCssModules2.default)(_HomeSearch2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(THHomeSearch, _Component);

  function THHomeSearch(props) {
    (0, _classCallCheck3.default)(this, THHomeSearch);

    var _this = (0, _possibleConstructorReturn3.default)(this, (THHomeSearch.__proto__ || (0, _getPrototypeOf2.default)(THHomeSearch)).call(this, props));

    _this.onChangePath = _this.onChangePath.bind(_this);

    if (!(typeof _this.onChangePath === 'function')) {
      throw new TypeError('Value of "this.onChangePath" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangePath));
    }

    return _this;
  }

  (0, _createClass3.default)(THHomeSearch, [{
    key: 'onChangePath',
    value: function onChangePath(e) {
      e.target.blur();
      var destination = e.target.value;
      if (destination === 'Bangkok' || destination === 'Phuket' || destination === 'Chiang Mai') {
        window.location = 'https://experience.takemetour.com/' + destination;
      } else if (destination === 'Ayutthaya') {
        window.location = 'https://experience.takemetour.com/Bangkok/1?focus=ayutthaya-historical-park';
      } else if (destination === 'Kanchanaburi') {
        window.location = 'https://experience.takemetour.com/Bangkok/1?focus=kanchanaburi-death-railway';
      } else if (this.props.userConfig.tourTypeEnabled) {
        // depreacted
        if (!this.props.tourType) {
          this.props.push('/tour' + (e.target.value && '?location=' + e.target.value));
        } else {
          this.props.push('/to/' + (e.target.value || 'Any') + ('?tags=' + this.props.tourType));
        }
      } else if (this.props.userConfig.preActivitiesEnabled) {
        // deprecated
        this.props.push('/activity' + (e.target.value && '?location=' + e.target.value));
      } else {
        this.props.setLastTripId(); // clear back behavior
        // this.props.push(`/to/${e.target.value || 'Any'}?sort=Recommended`);
        this.props.push('/to/' + (e.target.value || 'Any'));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var messages = this.props.messages;

      return _react3.default.createElement(
        'div',
        { styleName: 'th-dropdown-select-container' },
        _react3.default.createElement(
          'div',
          { styleName: 'th-dropdown-select' },
          _react3.default.createElement(_DestinationSelect2.default, {
            locale: this.props.locale,
            messages: {
              popular_cities: messages['nav.select_dropdown.dropdown_placeholder.popular_cities'],
              cities: messages['nav.select_dropdown.dropdown_placeholder.cities']
            },
            groupDestinationsByCountry: this.props.groupDestinationsByCountry,
            onSelect: this.onChangePath,
            placeholder: messages['nav.select_dropdown.dropdown_placeholder'],
            destinations: this.props.destinations
          }),
          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.select_dropdown.dropdown_placeholder', key: 'des-0' }),
          _react3.default.createElement('div', { styleName: 'dropdown-arrow', key: 'des-1' })
        )
      );
    }
  }]);
  return THHomeSearch;
}(_react2.Component), _class2.propTypes = {
  destinations: _react2.PropTypes.array,
  push: _react2.PropTypes.func,
  // isOpenMobileQuickSearch: PropTypes.bool,
  // openMobileQuickSearch: PropTypes.func,
  userConfig: _react2.PropTypes.object,
  setLastTripId: _react2.PropTypes.func,
  logCustomizeTrip: _react2.PropTypes.func,
  messages: _react2.PropTypes.object,
  locale: _react2.PropTypes.string,
  tourType: _react2.PropTypes.string,
  groupDestinationsByCountry: _react2.PropTypes.bool
}, _class2.defaultProps = {
  destinations: {}
}, _temp)) || _class));

exports.default = THHomeSearch;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/THHomeSearch.js
// module id = 1535
// module chunks = 47